function create_dashboard_html () {
    let dashboard_list = [
        { title: '傷亡失蹤', id: 'live_broadcast_heart-broken' },
        { title: '案件統計', id: 'live_broadcast_phone-call' },
        { title: '疏散收容', id: 'live_broadcast_open-home' },
        { title: '雨量站', id: 'live_broadcast_rain' },
        { title: '土石流警戒', id: 'live_broadcast_debris' },
        { title: '淹水感知器 ', id: 'live_broadcast_flood_sensor' },
        { title: '車行地下道', id: 'live_broadcast_underpass' },
        { title: '抽水站', id: 'live_broadcast_pump' },
        { title: '移動抽水機', id: 'live_broadcast_m_pumper' },
        { title: '橫移門', id: 'live_broadcast_water_door' },
        { title: '央管水位', id: 'live_broadcast_water_stage' },
        // { title: '市管水位', id: 'live_broadcast_water_stage_local' },
        { title: '水庫洩洪', id: 'live_broadcast_reservior'},
        { title: '員山子分洪道', id: 'live_broadcast_outflow' },
        { title: '淹水警戒', id: 'live_broadcast_flooding' },
        { title: '停班停課', id: 'live_broadcast_ban' },
        { title: '道路封閉', id: 'live_broadcast_road-break'},
        { title: '維生管線', id: 'live_broadcast_flash'},
    ].map(el => `
        <div class="d-flex mb-1 p-1 rounded" style="background-color: #ffffffcc">
            <div class="font-weight-bold" style="width:22%">${el.title}</div>
            <div id="${el.id}" style="width:80%"></div>
        </div>
    `)

    // if user doesn't choose event project, then remove first 3 elements in above list
    if (!raw_data['selected_project_id'] || !raw_data['selected_project_type']) {
        dashboard_list.splice(0, 3)
    }

    return dashboard_list.join('')
}

function create_predict_html () {
    let predict_list = [
        { title: '降雨', id: 'predict_result_rain' },
        { title: '午後雷陣雨', id: 'predict_result_afternoon_rain' },
        { title: '淹水', id: 'predict_result_flood' },
        { title: '土石流', id: 'predict_result_debris' },
    ].map(el => `
        <div class="mr-2 font-weight-bold"
            style="background-color: #ffffff30; border-radius: 5px; width: 24.5%">
            <h6 class="text-center text-white">${el.title}</h6>
            <h5 id="${el.id}" class="text-center text-warning">等待中...</h5>
        </div>
    `)

    return predict_list.join('')
}

function predict_result () {
    var today = get_time_string(0).slice(0,10).replaceAll('-', '')
    var date_list = ajax_call(publicPath + `/napi/simulate/airain/${today}_0000/${today}_2350`)
    if (date_list.length == 0) {
        $("#predict_result_rain").html('0處')
    } else {
        ajax_call_async(publicPath + `/napi/simulate/airain/${date_list[0].time}`, function(res){
            $("#predict_result_rain").html(res.village.length + '處')
        })
    }
    ajax_call_async(publicPath + `/napi/simulate/watchncdr?query_date=${today}`, function(res){
        let total = (res.conclusion["08"] +  res.conclusion["09"] + res.conclusion["10"] + res.conclusion["11"]) / 4
        $("#predict_result_afternoon_rain").html(res.conclusion["11"] >= 7 || total >= 7 ? "是" : "否")
    })
    var time_list = ajax_call(publicPath + "/napi/simulate/roadflood/list")
    ajax_call_async(publicPath + `/napi/simulate/roadflood/village/${time_list[0].predict_ts}/1`, function(res){
        let total = Array.from(new Set(res.filter(el => el.villname !== null).map(el => el.villcode))).length
        $("#predict_result_flood").html(total + '處')
    })
    ajax_call_async(publicPath + `/napi/simulate/debrisaieventlist`, function(res){
        $("#predict_result_debris").html(res[0]?.debris_count ?? 0 + '條')
    })
}

function topic_live_broadcast_test () {
    const dashboard_html = create_dashboard_html()
    const predict_html = create_predict_html()
    const district_options = [
        '板橋區', '三重區', '中和區', '永和區', '新莊區', '新店區', '土城區', '汐止區', '樹林區', '鶯歌區',
        '三峽區', '淡水區', '八里區', '林口區', '泰山區', '五股區', '蘆洲區', '八里區', '深坑區', '烏來區',
        '平溪區', '石碇區', '坪林區', '瑞芳區', '雙溪區', '貢寮區', '金山區', '萬里區', '石門區'
    ].map(el => `<option value="${el}">${el}</option>`).join('')
    const cctv_template = ['雨量(10/10)', '淹水', '土石流', '雨量(強化三級)'].map((el, index) => `
        <div id="newest_alert_${index}" class="w-100 d-none">
            <h5 class="live_broadcast_title">最大${el}警戒鄰近CCTV</h5>
            ${Array(3).fill().map((_, i) => `
                <div style="height:210px; overflow: hidden">
                    <div id="newest_alert_cctv_${index}_${i}" class="text-center" style="height:240px; width: 105%; overflow:hidden">
                        最高警戒測站鄰近CCTV${i+1}
                    </div>
                </div>
                <div style="font-size: 10px">CCTV-${i+1} <span id="newest_alert_cctv_name_${index}_${i}"></span></div>
            `).join('')}
        </div>
    `).join('')

    $('#live_broadcast').html(
        '<div class="d-flex bg-dark">' +
            // 左側區域(災情看板、最新災情與警戒訊息、災情預測)
            `<div id="live_broadcast_left_area" class=" p-1" style="width: 35vw; height: 100vh; font-size:14px">
                <h5 class="live_broadcast_title">災情看板</h5>
                <div id="live_broadcast_dashboard" style="height: 30vh; overflow: auto; margin-bottom: 5px">${dashboard_html}</div>
                <h5 class="live_broadcast_title">最新災情與警戒訊息</h5>
                <div style="height: 35vh; overflow: hidden; margin-bottom: 5px">
                    <div id="live_broadcast_text" class="text-white"></div>
                </div>
                <h5 class="live_broadcast_title">災情預測</h5>
                <div class="d-flex" style="margin-bottom: 10px;">${predict_html}</div>
                <div id="close_live_broadcast" class="bg-danger text-center text-white font-weight-bold mb-1 p-1 rounded" style="cursor: pointer">返回EDP主系統</div>
            </div>` +
            // 中間區域(最高警戒測站點位、最新災情案件點位)
            `<div style="width: 35vw; height: 100vh" class="text-white p-1">
                <div style="height:53vh">
                    <h5 class="live_broadcast_title">最高警戒測站點位</h5>
                    <div class="p-2 d-flex align-items-start">
                        <h6 class="font-weight-bold">關注項目：</h6>
                        <select id="select_alert">
                            <option value="all">全部</option>
                            <option value="rain_eoc">雨量(10/10)</option>
                            <option value="flood">淹水</option>
                            <option value="debris">土石流</option>
                            <option value="rain_level3">雨量(強化三級)</option>
                        </select>
                        <h6 class="font-weight-bold ml-5">行政區：</h6>
                        <select id="select_district" class="w-20">
                            <option value="all">全部</option>
                            ${district_options}
                        </select>
                    </div>
                    <div id="newest_alert" class="h6 px-2" style="height: 11vh; overflow: auto"></div>
                    <div style="width:100%; height:27vh" class="px-2">
                        <div id="newest_alert_map" class="w-100 h-100">
                            <div class="live_dashboard_legends_bar">
                                <img width="12" height="12" src="marker_icon/target_point.png"/><span>警戒測站</span>
                                <img width="12" height="12" src="marker_icon/nearest_cctv1.png"/><span>CCTV-1</span>
                                <img width="12" height="12" src="marker_icon/nearest_cctv2.png"/><span>CCTV-2</span>
                                <img width="12" height="12" src="marker_icon/nearest_cctv3.png"/><span>CCTV-3</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="height:47vh">
                    <h5 class="live_broadcast_title">最新災情案件點位</h5>
                    <div id="newest_event" class="h6 px-2" style="height: 11vh"></div>
                    <div style="width:100%; height:27vh" class="px-2">
                        <div id="newest_event_map" class="w-100 h-100">
                            <div class="live_dashboard_legends_bar">
                                <img width="12" height="12" src="marker_icon/target_point.png"/><span>災情點位</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>` +
            // 右側區域(最高警戒測站鄰近CCTV*3)
            `<div style="width: 30vw; height: 100vh; border-left:3px solid #343a40" class="text-white p-1">
                ${cctv_template}
            </div>` +
        '</div>'
    )
    $('#newest_alert_0').removeClass('d-none')

    setTimeout(function(){
        board_info_initial(raw_data['selected_project_id']) // insert data into dashboard_html
        predict_result() // insert data into predict_html
        if (raw_data["event"]) event_sta(raw_data["event"])
        else $('#newest_event').html('！！！尚未選擇災情專案！！！')
    }, 500)

    setTimeout(function(){
        // 初始地圖設定
        var newest_event_map = L.map('newest_event_map', {
            attributionControl: false,
            zoomControl: false,
            center: [25.033, 121.565],
            zoom: 15,
            zoomSnap: 1,
            layers: L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
                maxZoom: 22,
                subdomains:['mt0','mt1','mt2','mt3'],
                opacity: 0.8
            })
        })
        var newest_alert_map = L.map('newest_alert_map', {
            attributionControl: false,
            zoomControl: false,
            center: [25.033, 121.565],
            zoom: 15,
            zoomSnap: 1,
            layers: L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
                maxZoom: 22,
                subdomains:['mt0','mt1','mt2','mt3'],
                opacity: 0.8
            })
        })
        // 初始資料定義
        var nv_rain = [],
            nv_flood = [],
            nv_debris = [],
            nv_project = [], ov_project = [],
            to_render = []

        var rendered_array = {
            rain_10min: [],
            flood: [],
            debris: [],
            rain_1hr: [],
            project: []
        }

        var rendered_array_text = {
            rain_10min: [],
            flood: [],
            debris: [],
            rain_1hr: [],
            project: []
        }

        var rendered_array_all = []

        // 災情案件資料
        if (raw_data['selected_project_id'] && raw_data['selected_project_type']) {
            let res = ajax_call(publicPath + `/napi/emis/event?project_id=${raw_data['selected_project_id']}&type=${raw_data['selected_project_type']}`)
            ov_project = res[0]
        }


        function render_alert_event() {
            // 每2分鐘發一次api: rain_10min(10/10), flood, debris, rain_1hr(強化三級)
            nv_rain = ajax_call(publicPath + "/napi/obs/rainobs")
            if (Array.isArray(nv_rain)) {
                nv_rain = nv_rain.filter(el => {
                    const high_dist = ['鶯歌區', '五股區', '林口區', '三芝區', '深坑區', '烏來區', '平溪區', '石碇區', '坪林區']
                    return el.status !== '離線' && high_dist.includes(el.TOWN) ? el.ELEV < 300 : el.ELEV < 60
                })
                rendered_array.rain_10min = nv_rain.sort((a, b) => b.MIN_10 - a.MIN_10)
                rendered_array.rain_1hr = nv_rain.sort((a, b) => b.RAIN - a.RAIN)
            } else {
                console.error("nv_rain is not defined or is not an array");
            }
            let raw_flood = ajax_call(publicPath + "/napi/flood/get_flood_sensor_list_obs/all")
            nv_flood = raw_flood.data?.filter(el => el.status !== '離線') || []
            if (Array.isArray(nv_flood)) {
                rendered_array.flood = nv_flood.sort((a, b) => b.level - a.level)
            } else {
                console.error("nv_flood is not defined or is not an array");
            }
            let raw_debris = ajax_call(publicPath + "/napi/obs/debrisalert")
            let debris_rivers = ajax_call("geojson/swcb/SWCB_Debris.geojson")

            if (Array.isArray(raw_debris)) {
                nv_debris = raw_debris.filter(el => el.county == '新北市').map(el => (
                    {
                        ...el,
                        id: debris_rivers.features.find(i => i.properties.Debrisno == el.debrisNo).properties.Debrisno,
                        name: debris_rivers.features.find(i => i.properties.Debrisno == el.debrisNo).properties.Full,
                        status_value: el.alert_date == "" ? 1 : 2,
                        status: el.alert_date == "" ? '黃色' : '紅色',
                        lat: debris_rivers.features.find(i => i.properties.Debrisno == el.debrisNo).geometry.coordinates[0][0][1],
                        lon: debris_rivers.features.find(i => i.properties.Debrisno == el.debrisNo).geometry.coordinates[0][0][0]
                    })
                )
                rendered_array.debris = nv_debris.sort((a, b) => b.status_value - a.status_value)
            } else if (raw_debris.errorMessage == '目前無警戒') {
                rendered_array.debris = debris_rivers.features.map(el => ({
                    ...el.properties,
                    status: '正常',
                    name: el.properties.Full,
                    lat: el.geometry.coordinates[0][0][1],
                    lon: el.geometry.coordinates[0][0][0]}))
            } else {
                console.error("nv_debris is not defined or is not an array");
            }
            // 中上區塊：警戒輪播 (降雨量EOC、淹水、土石流、降雨強化三級 前三測站) & 右側區塊：鄰近 CCTV *3
            // 輪播計時器
            var alert_order = 0

            const alert_text_handler = (status, type) => {
                return status == '正常' ? `未達${type}警戒` : `達${status}警戒`
            }
            const render_alert = () => {
                if (alert_order == 4) {
                    clearInterval(alertInterval)
                }

                // 取得輪播資料
                let select_district = $('#select_district').val()
                let newest_alert = { rain_10min: '', flood: '', debris: '', rain_1hr: '' }
                let new_rendered_array = { rain_10min: [], flood: [], debris: [], rain_1hr: [] }

                if (select_district != 'all') {
                    new_rendered_array.rain_10min = rendered_array.rain_10min.filter(el => el.TOWN == select_district)
                    new_rendered_array.flood =  rendered_array.flood.filter(el => el.townname == select_district)
                    new_rendered_array.debris =  rendered_array.debris.filter(el => el.town == select_district)
                    new_rendered_array.rain_1hr = rendered_array.rain_1hr.filter(el => el.TOWN == select_district)
                } else {
                    new_rendered_array.rain_10min = rendered_array.rain_10min
                    new_rendered_array.flood = rendered_array.flood
                    new_rendered_array.debris = rendered_array.debris
                    new_rendered_array.rain_1hr = rendered_array.rain_1hr
                }
                new_rendered_array.rain_10min = new_rendered_array.rain_10min.slice(0, 3)
                new_rendered_array.flood = new_rendered_array.flood.slice(0, 3)
                new_rendered_array.debris = new_rendered_array.debris.slice(0, 3)
                new_rendered_array.rain_1hr = new_rendered_array.rain_1hr.slice(0, 3)

                for (let i = 0; i < new_rendered_array.rain_10min.length ; i++) {
                    newest_alert.rain_10min += `<div>
                        ${new_rendered_array.rain_10min[i].STNM}：10分鐘雨量${new_rendered_array.rain_10min[i].MIN_10} mm、
                        ${alert_text_handler(new_rendered_array.rain_10min[i].status, '雨量')}
                    </div>`
                }
                for (let i = 0; i < new_rendered_array.flood.length; i++) {
                    newest_alert.flood += `<div>
                        ${new_rendered_array.flood[i].st_name}：
                        水位${new_rendered_array.flood[i].level} cm、
                        ${alert_text_handler(new_rendered_array.flood[i].status, '淹水')}
                    </div>`
                }
                for (let i = 0; i < new_rendered_array.debris.length; i++) {
                    newest_alert.debris += `<div>
                        ${new_rendered_array.debris[i].name}：
                        ${alert_text_handler(new_rendered_array.debris[i].status, '土石流')}
                    </div>`
                }
                for (let i = 0; i < new_rendered_array.rain_1hr.length; i++) {
                    newest_alert.rain_1hr += `<div>
                        ${new_rendered_array.rain_1hr[i].STNM}：1小時雨量${new_rendered_array.rain_1hr[i].RAIN} mm、
                        ${alert_text_handler(new_rendered_array.rain_1hr[i].status, '雨量')}
                    </div>`
                }

                render_highest_alert(alert_order, newest_alert, new_rendered_array, newest_alert_map)

                // 左上災情看板輪播 ??????????????????
                switch (alert_order % 3) {
                    case 0:
                        $('#live_broadcast_dashboard').scrollTop(0)
                        break
                    case 1:
                        $('#live_broadcast_dashboard').scrollTop(212)
                        break
                    case 2:
                        $('#live_broadcast_dashboard').scrollTop(424)
                        break
                }
                alert_order++
            }
            const alertInterval = setInterval(render_alert, 30000)
            render_alert()

            // 每2分鐘發一次api: project (有選擇專案才執行)
            // 中下區塊：災情輪播 (最新災情案件資訊)
            // 取得輪播資料
            if (raw_data['selected_project_id'] && raw_data['selected_project_type']) {
                let res = ajax_call(publicPath + `/napi/emis/event?project_id=${raw_data['selected_project_id']}&type=${raw_data['selected_project_type']}`)
                nv_project = res[0].concat(res[1])
                if (nv_project.some(el => el.DISA_LEVEL == '9' && el.STATUS == '04')) {
                    rendered_array.project = nv_project.filter(el => el.DISA_LEVEL == '9' && el.STATUS == '04')
                } else {
                    nv_project.forEach(el => {
                        if (!ov_project.map(x => x.DISA_NO).includes(el.DISA_NO)) {
                            // 比較前一次的資料，找出變動的部分 => 存入rendered array
                            rendered_array.project.push(el)
                        }
                    })
                    if (rendered_array.project.length == 0) {
                        rendered_array.project.push(nv_project[0])
                    }
                }
                ov_project = nv_project
                nv_project = []

                rendered_array_text.project = rendered_array.project.map((el) => {
                    return `<p class="p-1 h6" style="background-color: #ffffff30">
                        通報時間：${timeConverter(el.RPT_TIME)}；
                        嚴重程度：${el.DISA_LEVEL == 1 ? '輕微':'嚴重'}；
                        災害類型：${condition_disa_type(el.DISA_TYPE)}；
                        地址：${el.DISA_LOCATION}；
                    </p>`
                })
            }
            // 輪播計時器
            var event_order = 0
            const render_event = () => {
                if (event_order == rendered_array.project.length) {
                    clearInterval(eventInterval)
                    return
                }

                if (raw_data['selected_project_id'] && raw_data['selected_project_type']) {
                    $('#newest_event').html(`
                        <div>通報時間：${timeConverter(rendered_array.project[event_order].RPT_TIME)}</div>
                        <div>
                            嚴重程度：${condition_disa_level_component(rendered_array.project[event_order].DISA_LEVEL)}、
                            災害類型：${condition_disa_type(rendered_array.project[event_order].DISA_TYPE)}
                        </div>
                        <div>地址：${rendered_array.project[event_order].DISA_LOCATION}</div>
                    `)
                    let latlng = [rendered_array.project[event_order].WGS_Y, rendered_array.project[event_order].WGS_X]
                    // remove all layer on the map
                    newest_event_map.eachLayer(function (layer) {
                        if (layer instanceof L.TileLayer) return
                        newest_event_map.removeLayer(layer);
                    });
                    newest_event_map.setView(latlng, 13)
                    L.circleMarker(latlng,{ color: 'white', fillColor: 'red', fillOpacity: 0.8,}).addTo(newest_event_map)
                }
                event_order++
            }
            const eventInterval = setInterval(render_event, 15000)
            render_event()

            // 文字輪播
            // 取得輪播資料
            rendered_array_text.rain_10min = rendered_array.rain_10min.slice(0, 3).map((el) => {
                return `<p class="p-1 h6" style="background-color: #ffffff30">
                    觀測時間：${el.TIME}；
                    測站名稱：${el.STNM}；
                    10分鐘雨量：${el.MIN_10} mm；
                    ${alert_text_handler(el.status, '雨量')}
                </p>`
            })
            rendered_array_text.flood = rendered_array.flood.slice(0, 3).map((el) => {
                return `<p class="p-1 h6" style="background-color: #ffffff30">
                    觀測時間：${el.time}；
                    測站名稱：${el.st_name}；
                    水位：${el.level} cm；
                    ${alert_text_handler(el.status, '淹水')}
                </p>`
            })
            rendered_array_text.debris = rendered_array.debris.slice(0, 3).map((el) => {
                return `<p class="p-1 h6" style="background-color: #ffffff30">
                    觀測時間：${new Date().toLocaleString('zh-TW',{hour12: false})}；
                    測站名稱：${el.name}；
                    ${alert_text_handler(el.status, '土石流')}
                </p>`
            })
            rendered_array_text.rain_1hr = rendered_array.rain_1hr.slice(0, 3).map((el) => {
                return `<p class="p-1 h6" style="background-color: #ffffff30">
                    觀測時間：${el.TIME}；
                    測站名稱：${el.STNM}；
                    時雨量：${el.RAIN} mm；
                    ${alert_text_handler(el.status, '雨量')}
                </p>`
            })
            rendered_array_all = Object.values(rendered_array_text).reduce((acc, cur) => acc.concat(cur), [])
            // 輪播計時器
            var text_order = 0
            const textInterval = setInterval(() => {
                if (text_order == rendered_array_all.length) {
                    clearInterval(textInterval)
                }

                if (to_render.length == 10) to_render.pop()
                to_render.unshift(rendered_array_all[text_order])
                $('#live_broadcast_text').html(to_render.join(''))

                text_order++
            }, 3000)
        }
        render_alert_event()

        const apiInterval = setInterval(() => {
            render_alert_event()
            predict_result()
        }, 120000)

        // 回到主系統: 關閉live broadcast頁面
        $('#close_live_broadcast').click(() => {
            clearInterval(apiInterval)
            $('#live_broadcast').addClass('d-none');
        })
    }, 500)
}

function render_highest_alert(alert_order, newest_alert, rendered_array, newest_alert_map) {
    let select_alert = $('#select_alert').val(),
        newest_alert_info = '',
        newest_alert_latlng = [],
        cctv_order = 0

        if ((alert_order % 4 == 0 && select_alert == 'all') || select_alert == 'rain_eoc') {
        newest_alert_info = newest_alert.rain_10min,
        newest_alert_latlng = [rendered_array.rain_10min[0].LAT, rendered_array.rain_10min[0].LON]
        $('#newest_alert_3').addClass('d-none')
        $('#newest_alert_0').removeClass('d-none')
        cctv_order = 0

    } else if ((alert_order % 4 == 1 && select_alert == 'all') || select_alert == 'flood') {
        newest_alert_info = newest_alert.flood
        newest_alert_latlng = [rendered_array.flood[0]?.lat, rendered_array.flood[0]?.lon]
        $('#newest_alert_0').addClass('d-none')
        $('#newest_alert_1').removeClass('d-none')
        cctv_order = 1

    } else if ((alert_order % 4 == 2 && select_alert == 'all') || select_alert == 'debris') {
        newest_alert_info = newest_alert.debris
        newest_alert_latlng = [rendered_array.debris[0]?.lat, rendered_array.debris[0]?.lon]
        $('#newest_alert_1').addClass('d-none')
        $('#newest_alert_2').removeClass('d-none')
        cctv_order = 2

    } else {
        newest_alert_info = newest_alert.rain_1hr
        newest_alert_latlng = [rendered_array.rain_1hr[0].LAT, rendered_array.rain_1hr[0].LON]
        $('#newest_alert_2').addClass('d-none')
        $('#newest_alert_3').removeClass('d-none')
        cctv_order = 3
    }

    $('#newest_alert').html(newest_alert_info)
    // remove all layer on the map
    newest_alert_map.eachLayer(function (layer) {
        if (layer instanceof L.TileLayer) return
        newest_alert_map.removeLayer(layer);
    });
    newest_alert_map.setView(newest_alert_latlng, 13)
    L.circleMarker(newest_alert_latlng, { color: 'white', fillColor: 'red', fillOpacity: 0.8 }).addTo(newest_alert_map)

    // 右邊區塊：配合中上區塊呈現鄰近CCTV
    let alert_latlng = [
        [rendered_array.rain_10min[0].LAT, rendered_array.rain_10min[0].LON],
        [rendered_array.flood[0]?.lat, rendered_array.flood[0]?.lon],
        [rendered_array.debris[0]?.lat, rendered_array.debris[0]?.lon],
        [rendered_array.rain_1hr[0].LAT, rendered_array.rain_1hr[0].LON]
    ]
    for (let i = 0; i < 4; i++) {
        let cctv_query_alert = publicPath + `/cloud/geoserver/edp2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=edp2%3Apolice_cctv&cql_filter=DWITHIN(geom,%20POINT(${alert_latlng[i][1]}%20${alert_latlng[i][0]}),%202000,%20meters)&outputFormat=application%2Fjson`
        $.ajax({url: cctv_query_alert, type: 'get', dataType: 'json'}).done(function(data) {
            if (data.features.length != 0) {
                // data依遠近排序，最多取3筆
                const targetPoint = turf.point(alert_latlng[i].reverse())
                data.features = data.features.sort((a, b) => turf.distance(targetPoint, turf.point(a.geometry.coordinates), {units: 'meters'}) - turf.distance(targetPoint, turf.point(b.geometry.coordinates), {units: 'meters'}))

                // add nearest 3 cctv points
                for (let j = 0; j < Math.min(data.features.length, 3); j++) {
                    let cctv_info = data.features[j]?.properties
                    let cctv_name = cctv_info.name.split('.')[1]
                    $(`#newest_alert_cctv_${i}_${j}`).html(`
                        </div>
                        <iframe src="${publicPath}/napi/police/hlshtml/${cctv_info.id}?jwt=${localStorage.getItem('jwt_token')}"
                            width="100%" height="100%" class="overflow-hidden" frameborder="0" title="CCTV檢視">
                        </iframe>
                    `)
                    $(`#newest_alert_cctv_name_${i}_${j}`).html(`站名：${cctv_name}`)
                    if (i == cctv_order) {
                        L.circleMarker(data.features[j].geometry.coordinates.reverse(),{
                            color: 'white',
                            fillColor: ['yellow', 'green', 'blue'][j],
                            fillOpacity: 0.8
                        }).addTo(newest_alert_map)
                    }

                }
            } else $('#newest_alert_cctv').html('無鄰近CCTV')
        })
    }
}
